import digitalData from 'digital-data';
import {
    BUTTON_SUBMISSION,
    MODULE_CLICK,
    MY_ACCOUNT_SETTINGS,
    STASH,
    MY_HOMEPAGE,
    OVERLAY
} from '../constants';

const setButtonClickAnalytics = (output) => {
    const ddoEvent = {
        category: {
            primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
            eventName: MODULE_CLICK,
        },
        pageType: output.pageType || MY_HOMEPAGE,
        content: {
            widgets: [{
                action: 'interact',
                id: output?.id || '',
                name: 'projects',
                templates: 'workspace dashboard',
                campaign: 'n/a',
                component: output?.component || '',
                element: 'n/a'
            }]
        }
    };
    digitalData.event.push(ddoEvent);
};

const setOpenShareOverlayAnalytics = () => {
    const ddoEvent = {
        category: {
            primaryCategory: OVERLAY
        },
        eventInfo: {
            eventName: 'workspace dashboard: projects: share your project',
        }
    };
    digitalData.event.push(ddoEvent);
};

const setShareOverlayButtonClickAnalytics = (output) => {
    const ddoEvent = {
        category: {
            primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
            eventName: MY_ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: output?.settings
        }
    };
    digitalData.event.push(ddoEvent);
};

const setShareActionAnalytics = () => {
    const ddoEvent = {
        category: {
            primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
            eventName: MY_ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: 'homepage: workspace dashboard: share project: email'
        }
    };
    digitalData.event.push(ddoEvent);
};

const setCloseShareOverlayAnalytics = () => {
    const ddoEvent = {
        category: {
            primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
            eventName: MY_ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: 'homepage: workspace dashboard: share your project overlay: close'
        }
    };
    digitalData.event.push(ddoEvent);
};

const setClickthroughAnalytics = (output) => {
    const ddoEvent = {
        category: {
            primaryCategory: STASH
        },
        eventInfo: {
            eventName: MODULE_CLICK,
        },
        eventMode: STASH,
        stash: {
            pageType: MY_HOMEPAGE,
            content: {
                widgets: [{
                    id: output?.id || '',
                    name: 'projects',
                    campaign: 'n/a',
                    component: output?.component || '',
                    element: 'n/a'
                }]
            }
        }
    };
    digitalData.event.push(ddoEvent);
};

const setCloseCreateNewProjectOverlayAnalytics = () => {
    const ddoEvent = {
        category: {
            primaryCategory: BUTTON_SUBMISSION
        },
        eventInfo: {
            eventName: MY_ACCOUNT_SETTINGS,
        },
        myAccount: {
            settings: 'homepage: workspace dashboard: create new project overlay: close'
        }
    };
    digitalData.event.push(ddoEvent);
};

export const projects = () => {
    LIFE_CYCLE_EVENT_BUS.on('projects.interaction', ({ output }) => {
        const action = output?.action || '';

        switch (action) {
            case 'button-click':
                setButtonClickAnalytics(output);
                break;
            case 'open-share-overlay':
                setOpenShareOverlayAnalytics();
                break;
            case 'share-overlay-button-click':
                setShareOverlayButtonClickAnalytics(output);
                break;
            case 'share-action':
                setShareActionAnalytics();
                break;
            case 'close-share-overlay':
                setCloseShareOverlayAnalytics();
                break;
            case 'clickthrough':
                setClickthroughAnalytics(output);
                break;
            case 'close-create-new-project-overlay':
                setCloseCreateNewProjectOverlayAnalytics();
                break;
        }
    });
};
